import dispatcher from "../dispatcher"

export function refreshExceptionFilter() {
  dispatcher.dispatch({ type: "UPDATE_REFRESH_EXCEPTION_FILTER", data: true })
  dispatcher.dispatch({ type: "UPDATE_REFRESH_EXCEPTION_FILTER", data: false })
}

export function refreshPage() {
  dispatcher.dispatch({ type: "UPDATE_REFRESH_PAGE", data: true })
  dispatcher.dispatch({ type: "UPDATE_REFRESH_PAGE", data: false })
}
